import request  from "./request";
const api = { 
    submit: function (data) { 
        return request.post('/api/signUp/commit', data);
    },
}
export default api;